interface Point { label: string; value: number }
export function SvgLineChart({ data }: { data: Point[] }) {
  if (!data.length) return <p className="text-sm text-gray-500">Sin datos</p>;
  const width = 420, height = 180, max = Math.max(...data.map((d) => d.value)), min = Math.min(...data.map((d) => d.value)), range = max - min || 1, step = width / Math.max(1, data.length - 1);
  const points = data.map((d, i) => `${i * step},${height - ((d.value - min) / range) * height}`).join(' ');
  return (
    <svg role="img" aria-label="Serie temporal" viewBox={`0 0 ${width} ${height}`} className="w-full" preserveAspectRatio="none">
      <polyline fill="none" stroke="#0ea5e9" strokeWidth="2" points={points} />
      {data.map((d, i) => {
        const x = i * step, y = height - ((d.value - min) / range) * height;
        return <circle key={d.label} cx={x} cy={y} r={3} fill="#0284c7"><title>{`${d.label}: ${d.value}`}</title></circle>;
      })}
    </svg>
  );
}
